
import React, { useRef, useState } from "react";
import SVG from "react-inlinesvg";
import cogoToast from 'cogo-toast';
import { useSelector, shallowEqual, useDispatch } from "react-redux"
import { Form, Col, Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../../../_metronic/_helpers";
import * as handlers from "../../../../../../_redux/selected-user/selectedUserHandlers";

const UploadDocumentModal = ({showUploadDocumentModal, onHide, match}) => {

  /* Get user Basic information from redux */
  const userBasic = useSelector(({selectedUser}) => selectedUser.data.profile.basic, shallowEqual);

  const [validated, setValidated] = useState(false);
  const [fileName, setFileName] = useState("");
  const document = useRef("");

  // Redux dispatch
  const dispatch = useDispatch();

  
  /* File input Check */
  const fileSelected = e => {
    const file = e.target.files[0];
    document.current = "";
    setFileName(file.name);

    const fileName = file.name?.toLowerCase();
    if (!(fileName.endsWith(".jpg") || fileName.endsWith(".png") || fileName.endsWith(".jpeg"))){
      cogoToast.error("Invalid File Selection");
      return
    }

    if (file.size > 10000000){
      cogoToast.error("File too large (10mb Max)");
      return
    }

    /* Convert File to base64 */
    const reader = new FileReader()
    reader.readAsDataURL(file);
    
    reader.onload = _ => {
      document.current = reader.result
    };

    reader.onerror = e => {
      cogoToast.error(e.message);
    }
  }

  /* Upload Document */
  const handleSubmit = e =>  {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (form.checkValidity() && document.current !== "") {
      onHide();
      const formData = new FormData(form);
      const docData = {...Object.fromEntries(formData.entries()), document: document.current, meta: userBasic};
      dispatch(handlers.uploadUserDocument(match.params.userId, docData));
    }

    setValidated(true);
  }
    
  return (
    <Modal
        show={showUploadDocumentModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        onExited={_ => setValidated(false)}
      >
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        <Modal.Header >
          <Modal.Title id="contained-modal-title-vcenter">
            <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                <SVG
                    title=""
                    src={toAbsoluteUrl("/media/svg/files/jpg.svg")}
                />
            </span>
            Upload User Document
          </Modal.Title>
          <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true" className="d-block">×</span>
              <span className="sr-only">Close</span>
           </button>
        </Modal.Header>
        <Modal.Body>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="type">
                <Form.Label >Category</Form.Label>                
                <Form.Control
                      required
                      as="select"
                      className="mr-sm-2"
                      custom
                      name="type"
                  >
                      <option value=""></option>
                      <option value="PICTURE_ID">Picture ID</option>
                      <option value="PASSPORT">Passport</option>
                      <option value="PROOF_OF_ADDRESS">Proof of Address</option>
                      <option value="PICTURE_ID_PROOF_OF_ADDRESS">Picture ID w/ Proof of Address</option>
                      <option value="TAX">Tax</option>
                      <option value="TRUST_DOCUMENTS">Trust</option>
                  </Form.Control>
                <Form.Control.Feedback  type="invalid">Please provide document Category</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="idType">
                <Form.Label >Type</Form.Label>
                <Form.Control
                  type="text"
                  name="idType"
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="idValue">
                <Form.Label >Type Value</Form.Label>
                <Form.Control 
                  type="text" 
                  name="idValue" 
                />
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="document">
              <Form.Label >File</Form.Label>
                <Form.File 
                  lang="en"
                  custom
                  id="formcheck-api-custom"
                >
                <Form.File.Input 
                  required
                  onChange={fileSelected}
                  accept=".jpg, .jpeg, .png"
                />
                <Form.File.Label data-browse="Select">{fileName}
                </Form.File.Label>
                  <Form.Control.Feedback type="invalid">
                    Select document File
                  </Form.Control.Feedback>
                </Form.File>
              </Form.Group>
            </Form.Row>
        </Modal.Body>
        <Modal.Footer>
            <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate px-4"
            >
                Cancel
            </button>
            <> </>
            <button
                type="submit"
                className="btn btn-primary btn-elevate px-4 ml-4"
            >
                Upload
            </button>
        </Modal.Footer>
          </Form>
      </Modal>

        );
}

export default UploadDocumentModal;